
const reasons = [
  {
    icon: 'ri-team-line',
    title: 'Local Expert Teams',
    description: 'Dedicated technicians in every region who understand Florida\'s unique climate and energy challenges.',
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Fast Response Times',
    description: 'With teams across the state, we guarantee quick service — often same-day for emergency calls.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Licensed & Insured',
    description: 'Every technician is fully licensed, insured, and background-checked for your peace of mind.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Free Home Assessments',
    description: 'No-obligation energy assessments to identify the best savings opportunities for your home.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 bg-brand-sand">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-brand-red font-semibold text-sm uppercase tracking-widest mb-3">
            Why Homeowners Trust Us
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-brand-navy mb-4">
            Local Service, Statewide Quality
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            No matter where you are in Florida, you get the same exceptional service backed by our statewide reputation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-7 border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-14 h-14 bg-brand-red-light rounded-xl flex items-center justify-center mb-5 group-hover:bg-brand-red transition-colors duration-300">
                <i className={`${reason.icon} text-2xl text-brand-red group-hover:text-white transition-colors duration-300 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h4 className="text-lg font-bold text-brand-navy mb-2">
                <a href="#services" className="hover:text-brand-red transition-colors">{reason.title}</a>
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
